import PropTypes from 'prop-types'
import React from 'react'
import { Field } from 'react-final-form'

import TextFieldInner from './TextFieldInner'

/**
 * Component of Text input with possibility to use masks and rules inside forms <br />
 * <br />
 * By the way, you can pass more properties besides mentioned below. They will be passed to html input component.<br />
 * Note: <small>Indeed it's wrapper around TextFieldInner component to use it with final-form library.
 * So it would work only inside Final Form's wrapper component.
 * </small>
 * @param {object} props - properties of component
 * @return {component} svg element
 */
const TextField = props => {
  const { name, ...remainingProps } = props

  return (
    <Field
      {...remainingProps}
      name={name}
      type={remainingProps.type}
      component={TextFieldInner}
    />
  )
}

TextField.propTypes = {
  /** Name of input */
  name: PropTypes.string.isRequired,

  /** Force error text when there is error from server */
  forceSubmitError: PropTypes.string,

  /** Mask for input */
  mask: PropTypes.array,

  /** String to show it like a placeholder in a case with using a mask */
  maskPlaceholder: PropTypes.string,

  /** Custom placeholder for input tag with custom behavior (moving up) */
  placeholder: PropTypes.string,

  /** Error messages from server for whole form */
  submitErrors: PropTypes.array,

  /** Type of html input tag */
  type: PropTypes.oneOf(['text', 'number', 'tel', 'email']),

  /** Function to implement rules. It has to return error message. You may read about it in Introduction article */
  validate: PropTypes.func,

  /** Flag to hide bottom indent for error */
  withoutErrorIndent: PropTypes.bool,

  /** Is input disabled */
  isDisabled: PropTypes.bool,
}

TextField.defaultProps = {
  forceSubmitError: '',
  type: 'text',
  withoutErrorIndent: false,
}

export default TextField
